import mandatoryToReadService from '@/services/mandatoryToReadService';
import acknowledgeService from '@/services/acknowledgeService';
import readService from '@/services/readService';
import dateUtils from '@/common/dateUtils';

export default {
  byDateReadLatestFirst: (a, b) => {
    let aDate = a._userState.dateread;
    let bDate = b._userState.dateread;

    if (!aDate || !bDate) {
      console.debug('a: module', a._moduleId, 'dateread', aDate);
      console.debug('b: module', b._moduleId, 'dateread', bDate);
    }

    if (!aDate && !bDate) return b.title ? b.title.localeCompare(a.title) : 1;
    if (!aDate) return 1;
    if (!bDate) return -1;

    let date1 = dateUtils.parseISOStringToTime(aDate);
    let date2 = dateUtils.parseISOStringToTime(bDate);
    let diff = date2 - date1;
    if (diff < 0) return -1;
    if (diff > 0) return 1;
    return 0;
  },
  byUpdatedLatestFirst: (a, b) => {
    let aDate = a.dateupdated;
    let bDate = b.dateupdated;
    if (!aDate && !bDate) return 0;
    if (!aDate) return 1;
    if (!bDate) return -1;

    let date1 = dateUtils.parseISOStringToTime(aDate);
    let date2 = dateUtils.parseISOStringToTime(bDate);
    let diff = date2 - date1;
    if (diff < 0) return -1;
    if (diff > 0) return 1;
    return 0;
  },
  bySortField: (a, b) => {
    let diff = Number(a.sort) - Number(b.sort);
    if (diff < 0) return -1;
    if (diff > 0) return 1;
    return 0;
  },
  bySortFieldDesc: (a, b) => {
    let diff = Number(a.sort) - Number(b.sort);
    if (diff < 0) return 1;
    if (diff > 0) return -1;
    return 0;
  },
  byImportance: (a, b) => {
    //mandatoryToRead, quittieren, unread, latest to oldest
    let isMandatoryToRead_a = mandatoryToReadService.isMandatoryToReadAndNotRead(a);
    let isMandatoryToRead_b = mandatoryToReadService.isMandatoryToReadAndNotRead(b);
    if (isMandatoryToRead_a && !isMandatoryToRead_b) return -1;
    if (!isMandatoryToRead_a && isMandatoryToRead_b) return 1;

    let isToAcknowledge_a = acknowledgeService.isToAcknowledge(a);
    let isToAcknowledge_b = acknowledgeService.isToAcknowledge(b);
    if (isToAcknowledge_a && !isToAcknowledge_b) return -1;
    if (!isToAcknowledge_a && isToAcknowledge_b) return 1;

    let isUnread_a = readService.isUnread(a);
    let isUnread_b = readService.isUnread(b);
    if (isUnread_a && !isUnread_b) return -1;
    if (!isUnread_a && isUnread_b) return 1;

    let diff = Number(a.sort || 0) - Number(b.sort || 0);
    if (diff < 0) return -1;
    if (diff > 0) return 1;

    if (a.dateupdated !== b.dateupdated) {
      let aDateupdated = Date.parse(a.dateupdated);
      let bDateupdated = Date.parse(b.dateupdated);
      return aDateupdated - bDateupdated < 0 ? 1 : -1;
    }
    if (a.datecreated !== b.datecreated) {
      let aDatecreated = Date.parse(a.datecreated);
      let bDatecreated = Date.parse(b.datecreated);
      return aDatecreated - bDatecreated < 0 ? 1 : -1;
    }
    if (!a.title || !b.title) return 0;
    return a.title.toLowerCase() < b.title.toLowerCase() ? -1 : 1;
  },
};
